export async function createCustomerUseCase(customer_data, customerRepostitory) {
    const result = await customerRepostitory.create(customer_data);

    const entity = new customerRepostitory.model(result.data);

    if (!entity.isValid()) {
        throw new Error("customer inválido");
    }

    return result;
}